export const EXECUTION_KINDS = [
  "build",
  "run",
  "image_build",
  "image_run",
] as const;

export type ExecutionKind = (typeof EXECUTION_KINDS)[number];

export function isBuildExecutionKind(kind: ExecutionKind): boolean {
  return kind === "build" || kind === "image_build";
}

export function isRunExecutionKind(kind: ExecutionKind): boolean {
  return kind === "run" || kind === "image_run";
}

export function parseExecutionKind(value: unknown): ExecutionKind {
  if (
    typeof value !== "string" ||
    !EXECUTION_KINDS.includes(value as ExecutionKind)
  ) {
    throw new Error("Unknown execution kind");
  }
  return value as ExecutionKind;
}
